import { Button } from "./ui/button";

export function Navigation() {
  return (
    <nav className="flex items-center justify-between px-6 py-4 bg-background border-b border-border">
      <div className="text-2xl flex items-center gap-2">
        <img
          src="/images/logoAIOPS.png"
          alt="AIOPS icon"
          className="w-40 h-13 object-contain"
        />
      </div>
      <div className="flex items-center gap-8 text-2xl">
        <div className="hidden md:flex items-center gap-8">
          <a
            href="#overview"
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            Overview
          </a>
          <a
            href="#mainModules"
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            Modules
          </a>
          <a
            href="#features"
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            Features
          </a>
          <a
            href="#contacto"
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            Contact
          </a>
        </div>

        <Button className="bg-[#003566]/90 !text-white hover:!bg-custom-cta/90 text-md">
          Schedule a demo
        </Button>
      </div>
    </nav>
  );
}
